export enum EPostHogProperties {
	AGENT_ID = 'agent_id',
	DURATION_SECONDS = 'duration_seconds',

	TICKET_ID = 'ticket_id',
	NEW_STATUS = 'new_status',
	NOTE_LENGTH = 'note_length',

	WORKFLOW_TYPE = 'workflow_type',
	WORKFLOW_ID = 'workflow_id',
	EVENT_TYPE_ID = 'event_type_id',
	NUMBER_OF_QUESTIONS = 'number_of_questions',

	NOTE_ID = 'note_id',
	LEAD_ID = 'lead_id',
	VARIABLE_NAME = 'variable_name',
	VARIABLE_TYPE = 'variable_type',
}
